import { buildWhatsAppLink } from "../../lib/whatsapp";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ message }) {
  return (
    <a
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] hover:scale-105 hover:bg-[#1EBE5C] transition-transform"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
    </a>
  );
}
